import type { FC } from 'react';

import { Heading, Stack } from '@eneco/sparky';
import { HeadingProps } from '@eneco/sparky/types';

interface Props {
  title: string;
  size?: HeadingProps['size'];
  headingAs?: HeadingProps['as'];
}

export const BrandBoxTitle: FC<Props> = ({ title, size = 'L', headingAs = 'h2' }) => (
  <Stack gap="4">
    <Heading as={headingAs} size={size} color="textInverted">
      {title}
    </Heading>
  </Stack>
);
